<div class="payment-page">

  <div class="payment-card">

    <h2>Payment Checkout</h2>

    <!-- Service Summary -->

    <div class="summary-card">

      <h3>{{ bookingData?.service_name }}</h3>

      <div class="summary-row">
        <span>Category</span>
        <strong>{{ bookingData?.category?.name || bookingData?.category }}</strong>
      </div>

      <div class="summary-row">
        <span>Booking Date</span>
        <strong>
          {{ bookingData?.selectedDate?.day }}/
          {{ bookingData?.selectedDate?.month }}/
          {{ bookingData?.selectedDate?.year }}
        </strong>
      </div>

      <div class="summary-row">
        <span>Function</span>
        <strong>{{ bookingData?.function_name }}</strong>
      </div>

      <div class="summary-row">
        <span>Location</span>
        <strong>{{ bookingData?.location }}</strong>
      </div>

      <div class="summary-row total">
        <span>Total Amount</span>
        <strong>₹ {{ bookingData?.price }}</strong>
      </div>

    </div>

    <!-- FULL PAYMENT -->

    <div class="payment-box" *ngIf="paymentType=='FULL_PAYMENT'">

      <h3>💳 Full Payment</h3>

      <p>
        Complete payment is required before confirming your booking.
      </p>

      <div class="amount-box">
        ₹ {{ bookingData?.price }}
      </div>

      <button (click)="payFullPayment()">
Pay ₹ {{ bookingData?.price }}
</button>

    </div>

    <!-- ADVANCE -->

    <div class="payment-box" *ngIf="paymentType=='ADVANCE'">

      <h3>💰 Advance Payment</h3>

      <div class="summary-row">
        <span>Advance Amount</span>
        <strong>
          ₹ {{ bookingData?.payment?.advanceAmount }}
        </strong>
      </div>

      <div class="summary-row">
        <span>Remaining</span>
        <strong>
          ₹ {{ bookingData?.price - bookingData?.payment?.advanceAmount }}
        </strong>
      </div>

      <p>
        Remaining amount can be paid after the event.
      </p>

      <button (click)="payAdvance()">
Pay Advance
</button>

    </div>

    <!-- POSTPAID -->

    <div class="payment-box" *ngIf="paymentType=='POSTPAID'">

      <h3>📅 Postpaid Booking</h3>

      <p>
        No payment is required now.
      </p>

      <p class="info">
        Payment will be collected after the event is completed.
      </p>

      <button (click)="confirmPostpaid()">
Confirm Booking
</button>

    </div>

    <!-- CASH -->

    <div class="payment-box" *ngIf="paymentType=='CASH_ON_HAND'">

      <h3>💵 Cash On Hand</h3>

      <p>
        Payment will be collected directly by the merchant.
      </p>

      <p class="info">
        Your booking will be confirmed after submission.
      </p>

      <button (click)="confirmCashOnHand()">
Confirm Booking
</button>

    </div>

  </div>

</div>